import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import forOwn from 'lodash/forOwn'
import flow from 'lodash/fp/flow'
import fpSet from 'lodash/fp/set'
import get from 'lodash/get'
import set from 'lodash/set'

import {
    fetchResourceSuccess,
    updateResourceRequest,
    updateResourceSuccess,
    updateResourceFailure,
} from 'actions/ui/shared/resource'
import { TABLE } from 'const/widgets'
import { getFilterOverridesForPage } from 'helpers/widgets'
import { defaultPaginationAndSorter } from 'reducers/ui/defaults'

import { SharedState } from './state'

// Cases added to the shared/index createReducer; state is parent UI state
export const addResourceCases = (
    builder: ActionReducerMapBuilder<SharedState>
): void => {
    builder
        .addCase(fetchResourceSuccess, (state, action) => {
            const {
                payload: { pageName, data },
            } = action
            const filterOverrides = getFilterOverridesForPage(pageName, data)

            set(state, [pageName, 'resource'], data)
            forOwn(get(state, [pageName, 'widgets']), (widget) => {
                widget.filters = filterOverrides.mergeWithFilters
                    ? { ...widget.filters, ...filterOverrides.filters }
                    : filterOverrides.filters
                if (widget.type === TABLE) {
                    const paginationAndSorterObj =
                        defaultPaginationAndSorter(widget)
                    widget.pagination = { ...paginationAndSorterObj.pagination }
                    widget.sorter = { ...paginationAndSorterObj.sorter }
                }
            })
        })
        .addCase(updateResourceRequest, (state, action) => {
            const {
                payload: { pageName, updatingResourceKey },
            } = action
            return fpSet([pageName, updatingResourceKey], true, state)
        })
        .addCase(updateResourceSuccess, (state, action) => {
            const {
                payload: { pageName, updatingResourceKey, data },
            } = action
            return flow(
                fpSet([pageName, 'resource'], data),
                fpSet([pageName, updatingResourceKey], false)
            )(state)
        })
        .addCase(updateResourceFailure, (state, action) => {
            const {
                payload: {
                    pageName,
                    updatingResourceKey,
                    data: { message },
                },
            } = action
            return flow(
                fpSet([pageName, updatingResourceKey], false),
                fpSet([pageName, 'error'], message)
            )(state)
        })
}
